window.addEventListener('load', function () {

    setTimeout(function () {

        const breadcrumbContainer =
            document.querySelector('#collection_breadcrumb');

        if (!breadcrumbContainer) return;

        const currentUrl =
            (window.currentCollectionUrl || '').replace(/\/$/, '');

        const parentUrl =
            (window.parentCollectionUrl || '').replace(/\/$/, '');

        const parentTitle =
            window.parentCollectionTitle || '';

        if (!currentUrl) return;


        /*
         * --------------------------------------------------
         * GET GLOBO MENU TITLE
         *
         * IMPORTANT:
         * Do NOT remove "EFI Connection" here.
         *
         * Parent menu items should remain untouched.
         * --------------------------------------------------
         */

        function getMenuTitle(link) {

            if (!link) return '';

            const gmText =
                link.querySelector('.gm-text');

            if (gmText) {
                return gmText.textContent.trim();
            }

            return link.textContent.trim();
        }


        /*
         * --------------------------------------------------
         * CLEAN CURRENT COLLECTION TITLE ONLY
         *
         * Examples:
         *
         * EFI 3x™ 4.3L V6 – EFI Connection
         *                     ↓
         * EFI 3x™ 4.3L V6
         *
         * EFI 58x™ Product Line - EFI Connection
         *                     ↓
         * EFI 58x™ Product Line
         * --------------------------------------------------
         */

        function cleanCurrentBreadcrumbTitle(title) {

            return title
                .replace(
                    /\s*[-–—]\s*EFI Connection\s*$/i,
                    ''
                )
                .trim();

        }


        /*
         * --------------------------------------------------
         * FIND A COLLECTION IN GLOBO MENU
         * --------------------------------------------------
         */

        function findMenuItem(url) {

            let foundLink = null;
            let foundItem = null;

            document.querySelectorAll(
                '.gm-links a.gm-target'
            ).forEach(function (link) {

                if (foundItem) return;

                const href =
                    link.getAttribute('href');

                if (!href) return;

                let menuUrl = '';

                try {

                    const absoluteUrl =
                        new URL(
                            href,
                            window.location.origin
                        );

                    menuUrl =
                        absoluteUrl.pathname
                            .replace(/\/$/, '');

                } catch (e) {

                    menuUrl =
                        href
                            .split('?')[0]
                            .replace(/\/$/, '');

                }


                if (menuUrl === url) {

                    foundLink = link;

                    foundItem =
                        link.closest('.gm-item');

                }

            });


            if (!foundLink) {
                return null;
            }


            return {

                link: foundLink,

                item:
                    foundItem ||
                    foundLink.parentElement

            };

        }


        /*
         * --------------------------------------------------
         * GET GLOBO HIERARCHY
         *
         * Returns something like:
         *
         * ENGINE HARDWARE
         * Crank & Cam Signal Kits
         * EFI 3x™ Product Line
         * EFI 3x™ 4.3L V6 – EFI Connection
         * --------------------------------------------------
         */

        function getGloboHierarchy(menuItem) {

            const items = [];

            if (!menuItem) {
                return items;
            }


            /*
             * --------------------------------------------------
             * CURRENT / MENU ITEM
             * --------------------------------------------------
             */

            const currentLink =
                menuItem.querySelector(
                    ':scope > a.gm-target'
                ) ||
                menuItem.querySelector(
                    'a.gm-target'
                );

            if (currentLink) {

                const currentHref =
                    currentLink.getAttribute('href');

                if (currentHref) {

                    let currentMenuUrl = '';

                    try {

                        const absoluteUrl =
                            new URL(
                                currentHref,
                                window.location.origin
                            );

                        currentMenuUrl =
                            absoluteUrl.pathname
                                .replace(/\/$/, '');

                    } catch (e) {

                        currentMenuUrl =
                            currentHref
                                .split('?')[0]
                                .replace(/\/$/, '');

                    }


                    items.push({

                        title:
                            getMenuTitle(currentLink),

                        url:
                            currentMenuUrl

                    });

                }

            }


            /*
             * --------------------------------------------------
             * FIND GM HEADING
             * --------------------------------------------------
             */

            let heading =
                menuItem.previousElementSibling;

            while (heading) {

                if (
                    heading.classList.contains(
                        'gm-heading'
                    )
                ) {

                    const headingLink =
                        heading.querySelector(
                            'a.gm-target'
                        );

                    if (headingLink) {

                        const headingHref =
                            headingLink.getAttribute(
                                'href'
                            );

                        if (headingHref) {

                            let headingUrl = '';

                            try {

                                const absoluteUrl =
                                    new URL(
                                        headingHref,
                                        window.location.origin
                                    );

                                headingUrl =
                                    absoluteUrl.pathname
                                        .replace(
                                            /\/$/,
                                            ''
                                        );

                            } catch (e) {

                                headingUrl =
                                    headingHref
                                        .split('?')[0]
                                        .replace(
                                            /\/$/,
                                            ''
                                        );

                            }


                            items.push({

                                title:
                                    getMenuTitle(
                                        headingLink
                                    ),

                                url:
                                    headingUrl

                            });

                        }

                    }

                    break;
                }

                heading =
                    heading.previousElementSibling;

            }


            /*
             * --------------------------------------------------
             * FIND TOP LEVEL PARENT
             * --------------------------------------------------
             */

            const submenu =
                menuItem.closest('.gm-submenu');

            if (submenu) {

                const topParentItem =
                    submenu.parentElement;

                if (
                    topParentItem &&
                    topParentItem.classList.contains(
                        'gm-item'
                    )
                ) {

                    const topParentLink =
                        topParentItem.querySelector(
                            ':scope > a.gm-target'
                        ) ||
                        topParentItem.querySelector(
                            'a.gm-target'
                        );

                    if (topParentLink) {

                        const topParentHref =
                            topParentLink.getAttribute(
                                'href'
                            );

                        if (topParentHref) {

                            let topParentUrl = '';

                            try {

                                const absoluteUrl =
                                    new URL(
                                        topParentHref,
                                        window.location.origin
                                    );

                                topParentUrl =
                                    absoluteUrl.pathname
                                        .replace(
                                            /\/$/,
                                            ''
                                        );

                            } catch (e) {

                                topParentUrl =
                                    topParentHref
                                        .split('?')[0]
                                        .replace(
                                            /\/$/,
                                            ''
                                        );

                            }


                            items.push({

                                title:
                                    getMenuTitle(
                                        topParentLink
                                    ),

                                url:
                                    topParentUrl

                            });

                        }

                    }

                }

            }


            /*
             * --------------------------------------------------
             * REVERSE
             *
             * Current
             * Heading
             * Parent
             *
             * becomes:
             *
             * Parent
             * Heading
             * Current
             * --------------------------------------------------
             */

            items.reverse();


            /*
             * --------------------------------------------------
             * REMOVE DUPLICATE URLs
             * --------------------------------------------------
             */

            const unique = [];

            items.forEach(function (item) {

                const exists =
                    unique.some(function (existing) {

                        return (
                            existing.url ===
                            item.url
                        );

                    });

                if (!exists) {
                    unique.push(item);
                }

            });


            return unique;

        }


        /*
         * --------------------------------------------------
         * FIND CURRENT COLLECTION
         * --------------------------------------------------
         */

        let currentMenu =
            findMenuItem(currentUrl);

        let breadcrumbItems = [];


        /*
         * --------------------------------------------------
         * CASE 1:
         *
         * CURRENT COLLECTION EXISTS IN GLOBO
         * --------------------------------------------------
         */

        if (currentMenu) {

            breadcrumbItems =
                getGloboHierarchy(
                    currentMenu.item
                );


            /*
             * --------------------------------------------------
             * IMPORTANT:
             *
             * Clean ONLY the LAST breadcrumb item.
             * Parent items remain untouched.
             * --------------------------------------------------
             */

            if (breadcrumbItems.length) {

                const lastIndex =
                    breadcrumbItems.length - 1;

                breadcrumbItems[lastIndex].title =
                    cleanCurrentBreadcrumbTitle(
                        breadcrumbItems[lastIndex].title
                    );

            }

        }


        /*
         * --------------------------------------------------
         * CASE 2:
         *
         * CURRENT COLLECTION NOT IN GLOBO
         *
         * Use custom.parent_collection
         * --------------------------------------------------
         */

        else if (parentUrl) {

            /*
             * Find parent collection in Globo.
             */

            const parentMenu =
                findMenuItem(parentUrl);


            if (parentMenu) {

                breadcrumbItems =
                    getGloboHierarchy(
                        parentMenu.item
                    );


                /*
                 * --------------------------------------------------
                 * Add current collection.
                 *
                 * Try to find the current collection in Globo
                 * again before using document.title.
                 * --------------------------------------------------
                 */

                const currentMenuFallback =
                    findMenuItem(currentUrl);

                let currentTitle = '';


                if (currentMenuFallback) {

                    currentTitle =
                        getMenuTitle(
                            currentMenuFallback.link
                        );

                }


                /*
                 * Fallback only if current menu item
                 * cannot be found.
                 */

                if (!currentTitle) {

                    currentTitle =
                        document.title
                            .split('|')[0]
                            .trim();

                }


                /*
                 * Clean ONLY this current item.
                 */

                currentTitle =
                    cleanCurrentBreadcrumbTitle(
                        currentTitle
                    );


                breadcrumbItems.push({

                    title:
                        currentTitle,

                    url:
                        currentUrl

                });

            }


            /*
             * Parent also isn't found in Globo.
             */

            else {

                breadcrumbItems.push({

                    title:
                        parentTitle,

                    url:
                        parentUrl

                });


                let currentTitle =
                    document.title
                        .split('|')[0]
                        .trim();


                currentTitle =
                    cleanCurrentBreadcrumbTitle(
                        currentTitle
                    );


                breadcrumbItems.push({

                    title:
                        currentTitle,

                    url:
                        currentUrl

                });

            }

        }


        /*
         * --------------------------------------------------
         * NOTHING FOUND
         * --------------------------------------------------
         */

        if (!breadcrumbItems.length) {
            return;
        }


        /*
         * --------------------------------------------------
         * DEBUG
         * --------------------------------------------------
         */

        console.log(
            'EFI Breadcrumb Debug:',
            {
                currentUrl:
                    currentUrl,

                parentUrl:
                    parentUrl,

                parentTitle:
                    parentTitle,

                currentMenuFound:
                    !!currentMenu,

                breadcrumbItems:
                    breadcrumbItems
            }
        );


        /*
         * --------------------------------------------------
         * BUILD HTML
         * --------------------------------------------------
         */

        let html =
            '<ul class="collection-breadcrumb">';


        /*
         * HOME
         */

        html +=
            '<li class="breadcrumb-home">' +
                '<a href="/">Home</a>' +
            '</li>';


        /*
         * BREADCRUMB ITEMS
         */

        breadcrumbItems.forEach(
            function (item, index) {

                const isLast =
                    index ===
                    breadcrumbItems.length - 1;


                html +=
                    '<li' +
                    (
                        isLast
                            ? ' class="current"'
                            : ''
                    ) +
                    '>' +

                        '<a href="' +
                            item.url +
                        '">' +

                            item.title +

                        '</a>' +

                    '</li>';

            }
        );


        html += '</ul>';


        /*
         * --------------------------------------------------
         * INSERT
         * --------------------------------------------------
         */

        breadcrumbContainer.innerHTML =
            html;


    }, 1000);

});

// filter function scroll issue.
document.addEventListener('DOMContentLoaded', function () {
    let resetTimer;

    function resetBoostFilterAtTop() {
        if (window.scrollY > 5) {
            return;
        }

        clearTimeout(resetTimer);

        resetTimer = setTimeout(function () {
            const filter = document.querySelector(
                '.boost-sd__filter-tree-vertical-content'
            );

            const column = document.querySelector(
                '#boost-sd-filter-tree-column'
            );

            if (filter) {
                filter.style.position = 'static';
                filter.style.top = '';
                filter.style.zIndex = '';
            }

            if (column) {
                column.style.position = 'static';
            }
        }, 100);
    }

    window.addEventListener('scroll', resetBoostFilterAtTop, {
        passive: true
    });

    resetBoostFilterAtTop();
});